import { getIntrospectionQuery, IntrospectionQuery } from "graphql"

import { publicFetcher } from "./fetcher"
import { SchemaSnapshot } from "./schemaCompatibility"

// Introspection operations are not supported by the React Query codegen plugin.
const introspectSchema = publicFetcher<IntrospectionQuery, Record<string, never>>(
  getIntrospectionQuery({
    descriptions: false,
    directiveIsRepeatable: true,
    inputValueDeprecation: true,
  }),
)

export async function fetchSchemaCompatibility(
  baseline: SchemaSnapshot | null,
): Promise<{
  snapshot: SchemaSnapshot
  breaking: boolean
}> {
  const data = await introspectSchema()
  const worker = new Worker(
    new URL("./schemaCompatibility.worker.ts", import.meta.url),
    {
      type: "module",
    },
  )
  try {
    return await new Promise((resolve, reject) => {
      worker.onmessage = ({ data }) => {
        if (data.error) reject(new Error(data.error))
        else resolve(data)
      }
      worker.onerror = (event) => reject(new Error(event.message))
      worker.postMessage({ data, baseline })
    })
  } finally {
    worker.terminate()
  }
}
